export const splitText = (node) => {
	if (node.nodeType === Node.TEXT_NODE) {
		let fragment = document.createDocumentFragment();
		for (let i = 0; i < node.textContent.length; i++) {
			let lettreSpan = document.createElement("span");
			lettreSpan.textContent = node.textContent[i];
			fragment.appendChild(lettreSpan);
		}
		node.parentNode.replaceChild(fragment, node);
	} else if (node.nodeName.toLowerCase() === "a") {
		let child = node.childNodes;
		for (let i = 0; i < child.length; i++) {
			splitText(child[i]);
		}
	} else {
		let child = node.childNodes;
		for (let i = 0; i < child.length; i++) {
			splitText(child[i]);
		}
	}
};
